import { useI18n } from '@change-corgi/core-react/i18n';

import { useBusinessPageData } from 'src/app/pages/about/business/pageContext';

type Result = ModelHookResult<{
	html: string;
	styles: string;
	breadcrumbItems: Array<{ label: string; href: string }>;
}>;

export function usePageBody(): Result {
	const {
		data: { content, css },
	} = useBusinessPageData();
	const { translate } = useI18n();

	return {
		data: {
			html: content,
			styles: css,
			breadcrumbItems: [
				{ label: translate('fe.components.brand_pages_navbar.about'), href: '/about' },
				{ label: translate('fe.pages.about.section_business_model.header'), href: '/about/business-model' },
			],
		},
	};
}
